const lagosLGAs = [
	{
		id: 1,
		name: "agege",
	},
	{
		id: 2,
		name: "ajeromi-ifelodun",
	},
	{
		id: 3,
		name: "alimosho",
	},
	{
		id: 4,
		name: "amuwo-odofin",
	},
	{
		id: 5,
		name: "apapa",
	},
	{
		id: 6,
		name: "badagry",
	},
	{
		id: 7,
		name: "epe",
	},
	{
		id: 8,
		name: "eti-osa",
	},
	{
		id: 9,
		name: "ibeju-lekki",
	},
	{
		id: 10,
		name: "ifako-ijaiye",
	},
	{
		id: 11,
		name: "ikeja",
	},
	{
		id: 12,
		name: "ikorodu",
	},
	{
		id: 13,
		name: "kosofe",
	},
	{
		id: 14,
		name: "lagos-island",
	},
	{
		id: 15,
		name: "lagos-mainland",
	},
	{
		id: 16,
		name: "mushin",
	},
	{
		id: 17,
		name: "ojo",
	},
	{
		id: 18,
		name: "oshodi-isolo",
	},
	{
		id: 19,
		name: "somolu",
	},
	{
		id: 20,
		name: "surulere",
	},
];

export { lagosLGAs };
